import { render, staticRenderFns } from "./pdf_picker.vue?vue&type=template&id=06a4b6ec&scoped=true&"
import script from "./pdf_picker.vue?vue&type=script&lang=js&"
export * from "./pdf_picker.vue?vue&type=script&lang=js&"
import style0 from "./pdf_picker.vue?vue&type=style&index=0&id=06a4b6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a4b6ec",
  null
  
)

export default component.exports